// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerSpeed__button-a66591 {
  cursor: pointer;
  border-radius: 8px;
  color: var(--base-80);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  width: 40px;
}

.AudioPlayerSpeed__button-a66591:hover,
.AudioPlayerSpeed__button-a66591:focus {
  background-color: var(--base-20);
  color: var(--base-100);
}

.AudioPlayerSpeed__button-a66591:active {
  background-color: var(--base-30);
  color: var(--base-120);
}

.AudioPlayerSpeed__button-a66591:disabled {
  color: var(--base-60);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerSpeed/AudioPlayerSpeed.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,WAAA;AACF;;AAEA;;EAEE,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".button {\n  cursor: pointer;\n  border-radius: 8px;\n  color: var(--base-80);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  width: 40px;\n}\n\n.button:hover,\n.button:focus {\n  background-color: var(--base-20);\n  color: var(--base-100);\n}\n\n.button:active {\n  background-color: var(--base-30);\n  color: var(--base-120);\n}\n\n.button:disabled {\n  color: var(--base-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `AudioPlayerSpeed__button-a66591`
};
module.exports = ___CSS_LOADER_EXPORT___;
